import actions from './actions';

let initState = {
    salesDashboardLoader: false,
    salesDashboardDetails: '',
    salesDashboardError: '',
    customerAgedDuesLoader: false,
    customerAgedDuesDetails: '',
    customerAgedDuesError: '',
    inactiveCustomersLoader: false,
    inactiveCustomersDetails: '',
    inactiveCustomersError: '',
};

export default function salesDashboardReducer(state = initState, action) {
    switch (action.type) {
        case actions.SALES_DASHBOARD_START: {
            return {
                ...state,
                salesDashboardLoader: true
            };
        }
        case actions.SALES_DASHBOARD_SUCCESS: {
            return {
                ...state,
                salesDashboardLoader: false,
                salesDashboardDetails: action.payload
            };
        }
        case actions.SALES_DASHBOARD_FAILURE: {
            return {
                ...state,
                salesDashboardLoader: false,
                salesDashboardError: action.payload
            };
        }

        case actions.CUSTOMER_AGED_DUES_START: {
            return {
                ...state,
                customerAgedDuesLoader: true
            };
        }
        case actions.CUSTOMER_AGED_DUES_SUCCESS: {
            return {
                ...state,
                customerAgedDuesLoader: false,
                customerAgedDuesDetails: action.payload
            };
        }
        case actions.CUSTOMER_AGED_DUES_FAILURE: {
            return {
                ...state,
                customerAgedDuesLoader: false,
                customerAgedDuesError: action.payload
            };
        }

        case actions.INACTIVE_CUSTOMERS_START: {
            return {
                ...state,
                inactiveCustomersLoader: true
            };
        }
        case actions.INACTIVE_CUSTOMERS_SUCCESS: {
            return {
                ...state,
                inactiveCustomersLoader: false,
                inactiveCustomersDetails: action.payload
            };
        }
        case actions.INACTIVE_CUSTOMERS_FAILURE: {
            return {
                ...state,
                inactiveCustomersLoader: false,
                inactiveCustomersError: action.payload
            };
        }
        default:
            return state;
    }
}

